import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../../../classes/dto-selected-merchant-or-product";
import {
  SET_STORE_CART_SELECT_MERCHATS_ZONE,
  SET_STORE_CART,
} from "../../../../database/store-data";
import {
  STORE_SHEDULEDateNTime,
  STORE_DineType,
} from "../../../../database/store-names";
import { useState, useCallback, useEffect } from "react";
import { dto_cart_checkout } from "../../../../classes/dto-cart-checkout";
import { ENCRYPT_STORAGE } from "../../../../config/config";
import { GET_CART_COUNT } from "../../../../functions/funtion";
import { GET_CART } from "../../../../database/get-stored-data";
import { Colors } from "../../../../util/colors";
import Alert from "../../../../components/Alert";
var $ = require("jquery");

const QtyPlusViewOnProductListView = ({ item, goToProduct }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMinus, setShowMinus] = useState(false);
  const [quantity, setQuantity] = useState(0);

  //function to add the first item to the cart
  const CartAddNewItemList = useCallback(
    async (CartList, ProductInfo, i) => {
      if (i === 0 && CartList === undefined) {
        CartList = [];
        CartList.push(ProductInfo);
      } else if (i === -1) {
        CartList.push(ProductInfo);
      } else {
        CartList[i] = ProductInfo;
      }
      let cartCOunt = await GET_CART();
      if (cartCOunt === undefined) {
        await SET_STORE_CART_SELECT_MERCHATS_ZONE(
          dto_selected_merchant_or_product,
        );
      }

      dto_selected_final_merchant_or_product.MID = item.MID;
      await SET_STORE_CART(CartList);
      await GET_CART_COUNT();
      return;
    },
    [item.MID],
  );

  //function to change merchant from the cart
  const CartChangeMerchant = useCallback(
    async (CartList, ProductInfo, i) => {
      CartList = [];
      ENCRYPT_STORAGE.removeMultipleItems([
        "STORE_Cart",
        "STORE_Addons",
        "STORE_FinaleSelelctCartMerchantNZone",
      ]);
      await CartAddNewItemList(CartList, ProductInfo, i);
    },
    [CartAddNewItemList],
  );

  //function to add items to the cart
  const addToCart = useCallback(
    async (currentQuantity) => {
      await SET_STORE_CART_SELECT_MERCHATS_ZONE(
        dto_selected_merchant_or_product,
      );
      let LocalCart = await GET_CART();

      const ProductInfo = {
        LineID: LocalCart !== undefined ? LocalCart.length + 1 : 1,
        PID: item.PI,
        TID: item.TI,
        Code: item.C,
        ProductImageUrl: item.IU,
        Desc: item.D,
        USeqID: item.UI,
        UOM: item.U,
        UP: item.P,
        UD: item.UD,
        Qty: currentQuantity,
        DecPoint: item.DP,
        Total: 0,
        Modification: "",
        ExtraCost: 0,
        DocDiscount: 0,
        VAT: 0,
        TAXID: item.Y,
        MID: item.MID,
        GDescription: item.G,
        IsAvailable: item.A,
        ADDONLINEID: 0,
        UDPer: 0,
        IsRecommended: 0,
      };

      if (LocalCart === undefined) {
        await CartAddNewItemList(LocalCart, ProductInfo, 0);
      } else if (item.MID === dto_selected_final_merchant_or_product.MID) {
        const existingProductIndex = LocalCart.findIndex(
          (cartItem) => cartItem.PID === item.PI,
        );

        if (existingProductIndex !== -1) {
          LocalCart[existingProductIndex].Qty = currentQuantity;
        } else {
          LocalCart.push(ProductInfo);
        }
        SET_STORE_CART(LocalCart);
      } else {
        Alert.ConfirmationMessageBox({
          Tittle: "Change Merchant",
          Text: "Selecting a different Merchant will clear your current cart. Do you wish to continue?",
          Icon: "warning",
          ConfirmButtonText: "Yes",
          ConfirmButtonFunction: async () => {
            await CartChangeMerchant(LocalCart, ProductInfo, -1);
            await SET_STORE_CART_SELECT_MERCHATS_ZONE(
              dto_selected_merchant_or_product,
            );
            ENCRYPT_STORAGE.removeMultipleItems([
              STORE_SHEDULEDateNTime,
              STORE_DineType,
              STORE_DineType,
            ]);
            dto_cart_checkout.PromoHeader = "";
            dto_cart_checkout.PromoGuid = 0;
            dto_cart_checkout.PromoCODE = "";
            dto_cart_checkout.Comment = "";
          },
          DismissButtonFunction: () => {},
        });
        return;
      }
      let lbl = document.getElementById("viewBasketCount");
      if (lbl) {
        let cart = await GET_CART();
        if (cart === undefined) {
          $("#viewBasketCount").html(0);
          lbl.style.display = "none !important";
        } else {
          $("#viewBasketCount").html(cart.length);
          lbl.style.display = "block !important";
        }
      }
      await GET_CART_COUNT();
    },
    [item, CartAddNewItemList, CartChangeMerchant],
  );

  //function to delete an item from the cart
  const deleteFromCart = useCallback(async () => {
    let LocalCart = await GET_CART(); // Assuming GET_CART() retrieves the cart from local storage
    const productIndex = LocalCart.findIndex(
      (cartItem) => cartItem.PID === item.PI,
    );

    if (productIndex !== -1) {
      Alert.ConfirmationMessageBox({
        ConfirmButtonFunction: async () => {
          // Remove the product from the cart
          LocalCart.splice(productIndex, 1);

          // Update LineID for the remaining items
          LocalCart = LocalCart.map((item, index) => ({
            ...item,
            LineID: index + 1,
          }));

          await SET_STORE_CART(LocalCart);
          await GET_CART_COUNT();
          let lbl = document.getElementById("viewBasketCount");
          if (lbl) {
            let cart = await GET_CART();
            if (cart === undefined) {
              $("#viewBasketCount").html(0);
            } else {
              $("#viewBasketCount").html(cart.length);
            }
          }

          setQuantity(0);
          setShowMinus(false);
        },
        ConfirmButtonText: "Yes",
        DismissButtonFunction: () => {},
        Icon: "info",
        Text: "Are you sure you want to remove this item from your cart?",
        Tittle: "Remove From Cart",
      });
    }
  }, [item]);

  //function to check if a similar product is available in the cart
  const checkCartForProduct = useCallback(async () => {
    if (item.MID === dto_selected_final_merchant_or_product.MID) {
      const LocalCart = await GET_CART();
      if (LocalCart !== undefined) {
        const existingProduct = LocalCart.find(
          (cartItem) => cartItem.PID === item.PI,
        );
        if (existingProduct) {
          setQuantity(existingProduct.Qty);
          setShowMinus(existingProduct.Qty > 0);
        }
      }
    }
  }, [item]);

  useEffect(() => {
    checkCartForProduct();
  }, [checkCartForProduct, item]);

  //function to toggle and expand the quantity switch
  const toggleExpand = useCallback(
    (event) => {
      event.stopPropagation();
      setIsExpanded(!isExpanded);
    },
    [isExpanded],
  );

  //function to increase the product quantity
  const incrementQuantity = useCallback(
    (event) => {
      event.stopPropagation();
      setQuantity((prevQuantity) => {
        let newQuantity = prevQuantity + 1;
        if (item.Q > 0 && newQuantity > item.Q) {
          Alert.ConfirmationMessageBox({
            Tittle: "Maximum Quantity Reached",
            Text: `Sorry, you cannot add more than ${item.Q} of ${item.D}.`,
            Icon: "warning",
            ConfirmButtonText: "OK",
            DismissButtonFunction: () => {},
          });
          return prevQuantity; // Do not change the quantity if it exceeds the maximum
        }
        setShowMinus(true);
        // Expand the view when incrementing quantity from 0
        if (prevQuantity === 0) {
          setIsExpanded(true);
        }
        addToCart(newQuantity);
        return newQuantity;
      });
    },
    [addToCart, item.Q],
  );

  //function to decrease the product quantity
  const decrementQuantity = (event) => {
    event.stopPropagation();
    setQuantity((prevQuantity) => {
      const newQuantity = prevQuantity > 1 ? prevQuantity - 1 : 1;
      setShowMinus(newQuantity > 1);
      addToCart(newQuantity);
      return newQuantity;
    });
  };

  // Qty button: always add to cart (never navigate). Item click elsewhere handles navigation to product detail.
  const handleOnClick = useCallback(
    (event) => {
      if (!isExpanded && quantity === 0) {
        incrementQuantity(event);
      } else {
        toggleExpand(event);
      }
    },
    [isExpanded, quantity, incrementQuantity, toggleExpand],
  );

  return (
    <div
      id="qty"
      onClick={handleOnClick}
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        fontSize: "20px",
        color: isExpanded || quantity > 0 ? "white" : "black",
        backgroundColor:
          isExpanded || quantity > 0 ? Colors.DarkGreyScale : "white",
        border: "0.25px solid black",
        padding: "3px",
        borderRadius: "200px",
        cursor: "pointer",
        width: isExpanded ? "95px" : "37px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "0px",
        WebkitTapHighlightColor: "transparent",
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        userSelect: "none",
        touchAction: "manipulation",
      }}
    >
      {isExpanded ? (
        <>
          {quantity > 0 && (
            <>
              {showMinus ? (
                <div
                  onClick={decrementQuantity}
                  style={{
                    marginRight: "15px",
                    fontSize: "22px",
                    fontWeight: "bolder",
                  }}
                >
                  {" "}
                  -{" "}
                </div>
              ) : (
                <i
                  className="bi bi-trash"
                  onClick={deleteFromCart}
                  style={{ marginRight: "15px", fontSize: "17px" }}
                />
              )}
              <span
                style={{
                  fontSize: "14px",
                  marginRight: "15px",
                  fontWeight: "bolderer",
                }}
              >
                {quantity}
              </span>
            </>
          )}
          <div
            onClick={incrementQuantity}
            style={{ fontSize: "22px", fontWeight: "bolder" }}
          >
            +
          </div>
        </>
      ) : quantity > 0 ? (
        <span style={{ fontSize: "18px", fontWeight: "bolderer" }}>
          {quantity}
        </span>
      ) : (
        <div style={{ fontSize: "25px", fontWeight: "bolder" }}> + </div>
      )}
    </div>
  );
};

export default QtyPlusViewOnProductListView;
